/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import Button from '../../../../components/button';
import Modal from '../../../../components/modal';
import Checkbox from '../../../../components/checkbox/checkbox';
import PulpoField from '../../../../pulpo_visualizer/fields';
import styles from '../inspection.module.scss';
import tableStyles from '../../../../styles/general.module.scss';
import Clickable from '../../../../components/clickable/Clickable';
import closeIcon from '../../../../icons/closeIcon.svg';

class CompletionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTask: {}
    };
  }

  handleChecked = (selected) => {
    const { selectedTask } = this.state;
    const { handleAnswerChanged } = this.props;
    if (JSON.stringify(selectedTask) === JSON.stringify(selected)) {
      this.setState({ selectedTask: {} });
      handleAnswerChanged({}, 'taskDetails');
    } else {
      this.setState({ selectedTask: selected });
      handleAnswerChanged(
        {
          taskid: selected?.event?.id,
          date: selected?.end,
          email_date: moment().format()
        },
        'taskDetails'
      );
    }
  }

  render() {
    const {
      handleAnswerChanged,
      handleFieldErrorChanged,
      handleDateChanged,
      handleSubminInspection,
      answers,
      showDateerror,
      onClose,
      details,
      showFormErrors,
      allDataSources,
      requiredMap,
      showStartEndModel,
      translations,
      shiftTasks,
      history,
      auditTitle,
      user
    } = this.props;
    const { selectedTask } = this.state;

    let titles={
      confirm_title: { id: 'inspections.complete_inspections.start_end_dates', default: 'Please Confirm Starting and Ending Dates.' },
      btn_title: { id: 'inspections.complete_inspections.complete', default: 'Complete Inspection' },
      shift_task: { id: 'inspections.complete_inspections.shift_task',
      default: 'This inspection has the following Open Shift Tasks. Please select the task that needs to complete on submission of this inspection.' }
    };

    if (auditTitle) {
      titles={
        confirm_title: { id: 'safetyAudit.complete_audit.start_end_dates', default: 'Please Confirm Starting and Ending Dates.' },
        btn_title: { id: 'safetyAudit.complete_audit.complete', default: 'Complete Audit' },
        shift_task: { id: 'safetyAudit.complete_audit.shift_task',
        default: 'This audit has the following Open Shift Tasks. Please select the task that needs to complete on submission of this audit.' }
      };
    }

    const airportData = {
      location: user?.portal_airport?.location?.coordinates,
      map_style: user?.portal_airport?.airport_settings?.map_style,
      mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style
    };

    return (
      <Modal
        onClose={onClose}
        showIn={showStartEndModel}
        width="640px"
        minHeight="30%"
      >
        <div className={styles.modalContent}>
          <div className={styles.modalTitle}>
            <h1 className={styles.startHeading}>
              <FormattedMessage
                id={titles.confirm_title.id}
                defaultMessage={titles.confirm_title.default}
              />
            </h1>
            <Clickable
              onClick={() => onClose()}
              className={styles.closeIcon}
            >
              <img src={closeIcon} alt="X" />
            </Clickable>
          </div>
          <div style={{ position: 'relative' }} className={styles.modalBody}>
            <PulpoField
              key="start_date"
              id="start_date"
              type="datetime"
              translationID="inspections.complete_inspections.start_date"
              title="Starting Date"
              noDefault
              fromMeeting
              className={styles.datetime}
              handleValueChange={handleDateChanged}
              answer={(moment(answers.start_date).format())||(moment(answers.date).format())}
              showFieldErrors
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <PulpoField
              key="end_date"
              id="end_date"
              type="datetime"
              translationID="inspections.complete_inspections.end_date"
              title="Ending Date"
              noDefault
              fromMeeting
              className={styles.datetime}
              handleValueChange={handleDateChanged}
              answer={answers.end_date||new Date()}
              showFieldErrors
              handleFieldErrorChanged={handleFieldErrorChanged}
            />
            <div className={styles.details_form}>
              {details.fields.map(field => (
                  <>
                    {field?.type !== 'multi_level' && field.type !== 'map_location' && field?.display_separately && !(field.type?.includes('dataSource') && field?.dataSourceID === 'ds4') && (
                      <PulpoField
                        key={field.id}
                        {...field}
                        translation={translations && translations[field.title]}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap[field.id]}
                        answer={answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        allDataSources={allDataSources}
                        isInspection
                        isInsCompleted
                      />
                    )}
                    {field.type === 'map_location' && field?.display_separately && (
                      <PulpoField key={field.id} {...field} airportInfo={airportData}
                        handleValueChange={handleAnswerChanged}
                        isRequired={requiredMap[field.id]} answer={answers[field.id]}
                        showFieldErrors={showFormErrors}
                        handleFieldErrorChanged={handleFieldErrorChanged}
                        className={styles.fullWidth} addressEnabled={field?.address_location}
                        title={field?.address_location ? 'Address' : field.title}
                        translationID={field?.address_location ? 'custom_field.address.title' : field.title}
                      />
                    )}
                    {field?.type === 'multi_level' && field?.display_separately
                        && <>
                              {/* don't even change the props passing position here,
                              it will raise not displaying or page break issues */}
                              <PulpoField
                                {...field}
                                levels={{
                                  level_0: {
                                      title: `${field?.title}`
                                  },
                                  level_1: {
                                      title: `${field?.title} 1`
                                  },
                                  level_2: {
                                      title: `${field?.title} 2`
                                  }
                                }}
                                title={field?.title}
                                values={typeof field.values === 'object'
                                ?Object.values(field.values).map(item => ({ ...item, name: item.title })):[]}
                                handleValueChange={handleAnswerChanged}
                                handleFieldErrorChanged={handleFieldErrorChanged}
                                isRequired={requiredMap[field.id]}
                                showFieldErrors={showFormErrors}
                                forFormModule
                                answer={answers && answers[field.id]}
                                type="dataSourceMultiLevel"
                                key={field.id}
                                translation={translations && translations[field.title]}
                                disabled={(field.type === 'string' && field?.hide_default_text)}
                                allDataSources={allDataSources}
                                isInspection
                              />
                           </>
                      }
                  </>
              ))}
            </div>
            {showDateerror && (
            <small style={{ color: 'red' }}>
                  *Please Make Sure start date is before end date
            </small>
            )}
            {!history?.location?.state?.taskid && shiftTasks?.length > 0 && (
                <>
                  <h4>
                    <FormattedMessage
                      id={titles.shift_task.id}
                      defaultMessage={titles.shift_task.default}
                    />
                  </h4>
                  <hr />
                  {shiftTasks.map(task => (
                    <table className={tableStyles.table}>
                      <tr>
                        <td>
                          <Checkbox
                            id={task.id || task.end}
                            label=""
                            checked={selectedTask?.event?.shift_name === task?.event?.shift_name}
                            onChange={() => this.handleChecked(task)}
                          />
                        </td>
                        <td>
                          <div className={tableStyles.shift}>
                            {task?.event?.shift_name}
                          </div>
                        </td>
                        <td>
                          {task.title}
                        </td>
                      </tr>
                    </table>
                  ))}
                </>
            )}
          </div>
            <div className={styles.subButton}>
              <Button
                translationID="inspections.new.cancel"
                defaultText="Cancel"
                action="tertiary"
                className={styles.cancelButton}
                onClick={() => onClose()}
              />
              <Button
                action="secondary"
                onClick={handleSubminInspection}
                translationID={titles.btn_title.id}
                defaultText={titles.btn_title.default}
              />
            </div>
        </div>
      </Modal>
    );
  }
}

CompletionModal.propTypes = {
  icon: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handleGoInspections: PropTypes.func.isRequired,
  history: PropTypes.shape({}).isRequired
};

export default CompletionModal;
